var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-toggle",on:{"click":_vm.toggle}},[_c('div',{staticClass:"toggle-background",class:{ active: _vm.value }},[_c('div',{staticClass:"toggle-indicator",class:{ active: _vm.value }})]),_vm._v(" "),_c('span',{staticClass:"toggle-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e03c78b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UI/toogleSwitch/SimpleToggle.vue
// module id = null
// module chunks = 